import React from 'react';
import { Column, Columns } from '../../styled/Columns/wrappers';
import StatusIcon from '../../styled/StatusIcon';
import Text from '../../styled/Text';
import { useStockQuery } from '../../api/stock';
import { StockStatus } from '../../../@types/stock.enum';
import UserStorePanel from '../UserStorePanel';
import { getTextItemDeliveryText, webOrderAvailable } from '../../utils/stockStatus';

interface IStockStatusPanelStore {
  stockStatus?: IItemStockStatus;
  store: IPanelStore;
}

const PanelStockStatus = ({ store, stockStatus }: IStockStatusPanelStore) => (
  <div>
    <Columns className="space-half valign-middle">
      <Column>
        <StatusIcon status={stockStatus?.status} quantity={stockStatus?.availableItems} />
      </Column>
      <Column>
        <Text tone="alt">{getTextItemDeliveryText(store, stockStatus)}</Text>
      </Column>
    </Columns>
    {!webOrderAvailable(store) &&
      getTextItemDeliveryText(store, stockStatus) !==
        'Vänligen kontakta butiken för mer information' && (
        <Columns className="space-4 valign-middle">
          <Column>
            <Text tone="ghost">Webborder kan inte hämtas i denna butik</Text>
          </Column>
        </Columns>
      )}
  </div>
);

interface IStockStatusPanel {
  onClose: () => void;
  onSelectStore: (storeId: string) => void;
  selectedStoreId?: string | undefined;
  stockRequest: IItemStockRequest;
}

const StockStatusPanel = ({
  onClose,
  onSelectStore,
  selectedStoreId,
  stockRequest,
}: IStockStatusPanel) => {
  const { data: stock, isLoading: loadingStock } = useStockQuery(stockRequest);

  const filterByStockStatus = (stores: IPanelStore[]) =>
    stores.filter((store) => {
      const storeStockStatus = stock?.[store?.id];
      return storeStockStatus?.status === StockStatus.InStock;
    });

  const stockStatusSwitchOptions = {
    switchLabel: 'Visa endast butiker med lagersaldo',
    handleSwitch: filterByStockStatus,
    initialSwitchState: false,
  };

  return (
    <UserStorePanel
      switchOptions={stockStatusSwitchOptions}
      onClose={onClose}
      onSelectStore={onSelectStore}
      selectedStoreId={selectedStoreId}
      panelTitle="Välj butik"
      loading={loadingStock}
      allowedStoresFilter={(store: ILimitedStore) => store.showBalanceOnWeb}
      renderStatus={(store: IPanelStore) => (
        <PanelStockStatus store={store} stockStatus={stock?.[store?.id]} />
      )}
    />
  );
};

export default StockStatusPanel;
